/* eslint-disable import/no-restricted-paths */
/* eslint-disable import/group-exports */
import styled from "@emotion/styled/macro";

export const maxWidth = 768;
export const mobileMaxWidth = 750;
export const tabletMaxWidth = 850;
export const contentPadding = 70;
export const contentPaddingMobile = 16;

export const Container = styled.div`
  padding: 0px 64px;

  @media (max-width: 900px) {
    padding: 24px 64px;
  }

  @media (max-width: ${maxWidth}px) {
    padding: 20px;
  }
`;

export const Title = styled.div`
  font-size: 30px;
  font-weight: 300;
  @media (max-width: ${maxWidth}px) {
    font-size: 36px;
  }
`;

export const Collapse = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
`;

export const Product = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProductImage = styled.img<{ isMobile?: boolean }>`
  max-height: ${({ isMobile }) => (isMobile ? "147px" : "287px")};
  max-width: 100%;
  align-self: center;
  justify-self: center;
`;

export const DividedOne = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 100px;
  margin: 10px;
  align-items: flex-start;
  justify-content: center;
  @media (max-width: ${maxWidth}px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const SecondColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 100px;
  height: 100%;
  margin: 10px;
  align-items: flex-end;
  @media (max-width: ${maxWidth}px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    padding-top: 20px;
  }
`;

export const DividedTwo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 100px;
  height: 100%;
  margin: 10px;
  align-items: flex-start;
  justify-content: center;
  @media (max-width: ${maxWidth}px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    padding-top: 20px;
  }
`;

export const Header = styled.div`
  font-size: 36px;
  font-weight: 300;
  padding-bottom: 10px;
`;

export const PromoText = styled.div`
  font-weight: 200;
  padding-top: 20px;
  @media (max-width: ${maxWidth}px) {
    width: 70%;
  }
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 40px 0px 30px 0px;
  @media (max-width: ${maxWidth}px) {
    height: 502px;
  }
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 96px;
  margin: 0 auto;
  background: #f4f1ec;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  @media (max-width: ${maxWidth}px) {
    flex-direction: column;
    width: 100%;
    height: 136px;
    padding: 0px;
    align-items: flex-start;
    justify-content: space-evenly;
  }
`;

export const Total = styled.div`
  font-size: 30px;
  font-weight: 400;
  padding: 0px 20px 0px 20px;
  @media (max-width: ${maxWidth}px) {
    font-size: 22px;
  }
`;

export const ModalButtonContainer = styled.div`
  padding-top: 4px;
`;

export const ModalButton = styled.button`
  background: transparent;
  border: none;
  padding: 4px 0px 0px 0px;
  cursor: pointer;
`;

export const Modal = styled.div`
  .sr-modal-container {
    @media (max-width: ${maxWidth}px) {
      width: 352px;
      left: calc(50% - 352px / 2 + 0.5px);
    }
  }
`;

export const Grid = styled.div`
  display: grid;
`;

export const StyledCategory = styled.div`
  width: 100%;
  margin-top: 54px;
`;

export const StyledHeader = styled.div`
  margin-bottom: 21px;
`;

export const StyledFootnote = styled.div`
  text-align: right;
  font-style: italic;
  font-size: small;
  margin: 16px;
`;
